import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
import {ValidationError} from "../lib/errors";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class Group extends Base implements EntityType {
    groupId: uuid;
    name: string;
    description?: string | null;
    billableRate?: number | null;
    userIds: uuid[];
    constructor(doc: typeof Group | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            groupId: genUUID(),
            name: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "group";
        // @ts-ignore
        this.groupId = doc._groupId || doc.groupId || doc.groupid || genUUID();
        // @ts-ignore
        this.name = doc._name || doc.name || null;
        // @ts-ignore
        this.description = doc._description || doc.description || null;
        // @ts-ignore
        this.billableRate = util.coalesce(util.parseFloat(doc._billableRate), util.parseFloat(doc.billableRate), util.parseFloat(doc.billablerate), null);
        // @ts-ignore
        this.userIds = doc._userIds || doc.userIds || doc.userids || [];
    }
    get id(): uuid { return this.groupId; }
    addUserId(userId: uuid): uuid {
        if (!userId) throw new ValidationError('No nulls allowed in an array!');
        if (!this.userIds) this.userIds = [];
        this.userIds.push(userId);
        return userId;
    }
    updateUserId(userId: uuid) {
        if (!this.userIds) this.userIds = [];
        const index = this.userIds.findIndex(item => item === userId);
        if (index !== -1) { this.userIds[index] = userId; }
        else this.addUserId(userId);
    }
    removeUserId(userId: uuid) {
        if (!this.userIds) return;
        let foundItems = this.userIds?.filter(item => item === userId);
        if (foundItems && foundItems.length > 0) {
            this.userIds = this.userIds.filter(item => !(item === userId));
        }
    }
    abandonUserIds() { this.userIds = []; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for a group"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.groupId; }
    static override getNonRefArrayFields(): string[] { return ["userIds"]; }
    static override getDefaultEntries(): Group[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'group',
    table: 'GROUPS',
    comment: 'A named set of firm users that can be collectively assigned tasks. Any group member can claim and work a task assigned to the group, enabling workload sharing without manual reassignment. Groups also carry an optional default billable rate.',
    fields: {
        groupId: {
            type: 'uuid', required: true, pk: true, default: '__UUID__', comment: 'Unique ID for a group'
        },
        name: {
            type: 'string', required: true, comment: 'The name of the group'
        },
        description: {
            type: 'string', comment: 'Short description of the purpose of the group'
        },
        billableRate: {
            type: 'money', comment: 'Default billing rate for this group'
        },
        userIds: {
            type: 'uuid[]', entityType: 'user', comment: 'User IDs of group members'
        }
    },
    maps: [
        {name: 'userIds', keysFn: t => t.userIds, presentFn: (t, k) => t.userIds?.includes(k)}
    ]
});
    }
}
export default Group;
